import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Carousel from './Carousel';




const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const SampleReportDetails = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Sample Dashboard',
    paragraph: 'Your Test Results are Summarized Below.'
  };





  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  A Live Look
                  </div>
                <h3 className="mt-0 mb-12">
                   Latest Measurement Results
                  </h3>
                <p className="m-0">
                  The Most Recent Measurement Results are Analyzed and Uploaded to the Cloud for Review and Collaboration.
                  </p>
              </div>
            </div>

            <div className="split-item">
              <div className="center-content justify-content-center reveal-from-right">
              <Carousel/>
            </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
}

SampleReportDetails.propTypes = propTypes;
SampleReportDetails.defaultProps = defaultProps;

export default SampleReportDetails;